import { Form, Switch } from 'antd';

/** Whether dispatch refuses a driver who still owes cash from a finished trip; an approver can override it per trip (gitaumoses4/chukua#127). */
export function DispatchCashRuleField() {
  return (
    <Form.Item
      name="dispatchBlocksUnreconciledCash"
      label="Refuse drivers with unreconciled cash"
      valuePropName="checked"
      className="mb-0 sm:col-span-3"
      extra="A driver who still owes cash from a finished trip is blocked from the next one, and the picker says how much. An approver can override it for a trip."
    >
      <Switch />
    </Form.Item>
  );
}
